import { MenuItem, Select } from '@mui/material'
import { SelectChangeEvent } from '@mui/material/Select'
import React from 'react'
import { Warehouse } from '../../../interfaces'

/*
Copyright 2022-07-12 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Creación component WarehouseSelect
*/

interface SelectWarehouseProps {
  selectedWarehouse: number
  warehouses: Warehouse[] | undefined
  onChange: (warehouseId: number) => void
}

const SelectWarehouse: React.FC<SelectWarehouseProps> = ({
  warehouses,
  selectedWarehouse,
  onChange
}) => {
  const existSelectedWarehouse =
    warehouses?.filter((item) => item.id === selectedWarehouse).length || 0

  return (
    <Select
      labelId='create-ot-warehouse-select'
      id='create-ot-warehouse-select'
      disabled={warehouses?.length === 1}
      value={existSelectedWarehouse ? selectedWarehouse : 0}
      onChange={(event: SelectChangeEvent<number>) =>
        onChange(Number(event.target.value))
      }
      variant='outlined'
    >
      <MenuItem value={0}>
        <em>Seleccionar Almacén</em>
      </MenuItem>
      {warehouses !== undefined &&
        warehouses?.length > 0 &&
        warehouses?.map((el) => (
          <MenuItem value={el.id}>{el.warehouseName}</MenuItem>
        ))}
    </Select>
  )
}

export default SelectWarehouse
